// extracted by mini-css-extract-plugin
export default {"newTop":"NewTop_newTop__3ykse","buttons_top":"NewTop_buttons_top__1hxxh","button_top":"NewTop_button_top__2q9A5"};